'use client';

import { useRouter } from 'next/navigation';

import { ArrowLeft } from 'lucide-react';

const BACK_CLASS =
  'flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-raise/90 text-sink shadow-md transition hover:bg-white active:scale-95';

interface Props {
  /** Semantic parent the standalone page navigates Back to. */
  backHref: string;
  /** Intercept overlay → pop it (`router.back`); standalone → a plain `<a href>`. */
  intercepted?: boolean;
}

/**
 * The course hero's back control. Standalone page → a real `<a href>` that hard-
 * navigates to the semantic parent. Intercept overlay → a button that pops it.
 */
export function CourseHeroBackButton({ backHref, intercepted }: Props) {
  const router = useRouter();

  if (intercepted) {
    return (
      <button
        type="button"
        onClick={() => router.back()}
        aria-label="Back"
        className={BACK_CLASS}
      >
        <ArrowLeft className="h-5 w-5" aria-hidden />
      </button>
    );
  }

  return (
    <a href={backHref} aria-label="Back" className={BACK_CLASS}>
      <ArrowLeft className="h-5 w-5" aria-hidden />
    </a>
  );
}
